import { Centrifuge } from 'centrifuge';
import { createReducer } from 'redux-create-reducer';
import service from '../../../utils/axios';

// ACTION TYPES
export const REQUEST_INITIALIZE_SOCKET = 'REQUEST_INITIALIZE_SOCKET';
export const REQUEST_INITIALIZE_SOCKET_SUCCESS = 'REQUEST_INITIALIZE_SOCKET_SUCCESS';
export const REQUEST_INITIALIZE_SOCKET_FAILURE = 'REQUEST_INITIALIZE_SOCKET_FAILURE';

export const REQUEST_SOCKET_CONNECTED = 'REQUEST_SOCKET_CONNECTED';
export const REQUEST_SOCKET_DISCONNECTED = 'REQUEST_SOCKET_DISCONNECTED';
export const REQUEST_SOCKET_ERROR = 'REQUEST_SOCKET_ERROR';

const defaultState = {
  // SOCKET STATES
  isInitializingSocket: false,
  initializeSocketSuccess: false,
  initializeSocketFail: false,

  isConnected: false,
  isDisconnected: false,
  connectionError: null,

  currentSubscription: null,
  currentClient: null,
};

const reducer = createReducer(defaultState, {
  // SOCKET INITIALIZATION
  [REQUEST_INITIALIZE_SOCKET]: (state) => ({
    ...state,
    isInitializingSocket: true,
    initializeSocketFail: false,
    initializeSocketSuccess: false,
  }),
  [REQUEST_INITIALIZE_SOCKET_SUCCESS]: (state, action) => ({
    ...state,
    currentSubscription: action.payload.subscription,
    currentClient: action.payload.client,
    isInitializingSocket: false,
    initializeSocketFail: false,
    initializeSocketSuccess: true,
  }),
  [REQUEST_INITIALIZE_SOCKET_FAILURE]: (state) => ({
    ...state,
    isInitializingSocket: false,
    initializeSocketFail: true,
    initializeSocketSuccess: false,
  }),

  // CONNECTION EVENTS
  [REQUEST_SOCKET_CONNECTED]: (state) => ({
    ...state,
    isConnected: true,
    isDisconnected: false,
    connectionError: null,
  }),
  [REQUEST_SOCKET_DISCONNECTED]: (state) => ({
    ...state,
    isConnected: false,
    isDisconnected: true,
  }),
  [REQUEST_SOCKET_ERROR]: (state, action) => ({
    ...state,
    connectionError: action.payload.error,
  }),
});

export default reducer;
export const namespace = 'socket';

// FUNCTION TO GET TOKEN
export const getToken = async () => {
  try {
    const res = await service.post(`/realtime/token`);
    return res.token;
  } catch (e) {
    return null;
  }
};

// FUNCTION TO INITIALIZE SOCKET
export const initSocket = () => async (dispatch, getState) => {
  try {
    dispatch({ type: REQUEST_INITIALIZE_SOCKET });

    const state = getState();
    const { auth, socket } = state;
    const { user } = auth;

    if (socket.currentClient) {
      socket.currentClient.disconnect && socket.currentClient.disconnect();
    }

    const client = new Centrifuge(process.env.REACT_APP_CENTRIFUGO_URL, {
      getToken,
    });

    client.on('connected', () => {
      dispatch({ type: REQUEST_SOCKET_CONNECTED });
    });

    client.on('disconnected', () => {
      dispatch({ type: REQUEST_SOCKET_DISCONNECTED });
    });

    client.on('error', (ctx) => {
      dispatch({
        type: REQUEST_SOCKET_ERROR,
        payload: { error: ctx },
      });
    });

    client.connect();

    const CHANNEL_NAME = `${process.env.REACT_APP_CENTRIFUGO_PERSONAL_CHANNEL_NAMESPACE}:#${user.id}`;

    if (socket.currentSubscription) {
      socket.currentSubscription.unsubscribe && socket.currentSubscription.unsubscribe();
    }

    const subscription = client.newSubscription(CHANNEL_NAME);
    dispatch({
      type: REQUEST_INITIALIZE_SOCKET_SUCCESS,
      payload: { subscription, client },
    });
    subscription.on('publication', (ctx) => {
      if (!ctx.data) return;
      const { event, data } = ctx.data;
      console.log("🚀 ~ subscription.on ~ event:", event)
      console.log("🚀 ~ subscription.on ~ data:", data)
      dispatch({ type: event, payload: data });
    });
  } catch (e) {
    dispatch({ type: REQUEST_INITIALIZE_SOCKET_FAILURE });
  }
};
